import { useEffect } from 'react';

const BRAND = 'Petito';

/**
 * YouTube-style tab titles: "Account - Petito" (or just "Petito" when page is empty).
 */
export function useDocumentTitle(pageTitle?: string | null) {
    useEffect(() => {
        const page = (pageTitle ?? '').trim();
        document.title = page ? `${page} - ${BRAND}` : BRAND;
        return () => {
            document.title = BRAND;
        };
    }, [pageTitle]);
}

export const DOCUMENT_BRAND = BRAND;
